import '../css/style.css';
import '../css/animate.css';
import '../css/popup.css'
import '../css/parallaxgallery.css'
import logoB from '../images/logoB.png'
import React, { useEffect, useState, useRef} from 'react'
import { Link, Route, Routes, useLocation } from 'react-router-dom'
import bg3 from '../images/homeSlides/3.jpg'
import { ourBrands } from '../listbrands';
import { listSlides , rdesignImgs, areas, details} from '../listSlides';
import { listAbout } from '../listAbout';
import { catalogos } from '../listCatalogos';
import { services } from '../../services';
import { rdesign } from '../listVideos';
import PopUp from './PopUp';
import { FaEye} from "react-icons/fa";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPhone, faEnvelope, faMapMarkedAlt} from '@fortawesome/free-solid-svg-icons'
import { faFacebook, faInstagram, faLinkedin, faYoutube, faTiktok} from '@fortawesome/free-brands-svg-icons'
import { faHome, faUser, faSearch, faAngleDown, faDownload, faArrowRight, faSignOut, faChevronLeft,faLightbulb, faL, faHeart } from '@fortawesome/free-solid-svg-icons'
import useEmblaCarousel from "embla-carousel-react";
import Autoplay from "embla-carousel-autoplay";
import { FaHandshake} from "react-icons/fa";
import useWaypointAnimation from './hooks/useWaypointAnimation'
import useFullHeight from './hooks/useFullHeight'
import useNavbarScroll from './hooks/useNavbarScroll'
import "slick-carousel/slick/slick.css"; 
import $ from "jquery";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import "owl.carousel";
import "../css/cookies.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import ParallaxGallery from '../../utils/ParallaxGallery';
import { Trans } from 'react-i18next';
import { FaMedal} from "react-icons/fa";
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';
export default function Homepage() {
  const { t, i18n } = useTranslation();
  const [selectedLang, setSelectedLang] = useState(null);

  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const handleOpenPopup = () => {
    setIsPopupOpen(true);
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
  };

const [imagesLoaded, setImagesLoaded] = useState(0); 

const sliderOwl = useRef(null);
const setAnimatedRef = useWaypointAnimation();
const [windowHeight, setWindowHeight] = useState(window.innerHeight);

  useEffect(() => {
        const handleResize = () => {
            setWindowHeight(window.innerHeight);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

  useEffect(() => {
    const $ = window.jQuery; // jQuery do window
    if (!$ || !$.fn.owlCarousel) {
      console.error("jQuery ou Owl Carousel não carregados");
      return;
    }

    const $el = $(sliderOwl.current);
    // Inicializa o Owl Carousel
    $el.owlCarousel({
      items: 1,
      loop: true,
      nav: true,
      dots: true,
      autoplay: true,
      autoplayTimeout: 8000,
      smartSpeed: 800,
    });

    // Cleanup ao desmontar o componente
    return () => {
      if ($el.data("owl.carousel")) {
        $el.trigger("destroy.owl.carousel");
      }
    };
  }, []);

const sliderRef = useRef(null);
  const settings = {
    infinite: true,       // loop infinito
    speed: 4500,          // velocidade da transição
    autoplay: true,
    cssEase: "linear",
    autoplaySpeed: 0,
    variableWidth: true,
    slidesToScroll: 1,    // quantos rolam por vez
    arrows: false,        // sem setas
    responsive: [
      {
        breakpoint: 500,
        settings: { slidesToShow: 2 }
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 3 }
      },
      {
        breakpoint: 1025,
        settings: { slidesToShow: 5 }
      }
]
  };

  useEffect(() => {
    // força reset para o início após o mount
    if (sliderRef.current) {
      sliderRef.current.slickGoTo(0, true);
    }
  }, []);

  //Slide images react.js
  const totalSlides = rdesignImgs.length;
  const [currentSlide, setCurrentSlide] = useState(0);
  const carouselWrapperRef = useRef(null);
  const [itemWidth, setItemWidth] = useState(850); // Valor inicial

  // LÓGICA DE TRANSIÇÃO AUTOMÁTICA (a sua lógica original)
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide(prevSlide =>
        prevSlide === totalSlides - 1 ? 0 : prevSlide + 1
      );
    }, 5000); // 5 segundos

    return () => clearInterval(interval);
  }, [totalSlides]);

  // LÓGICA DE LARGURA RESPONSIVA (a solução com useRef)
  useEffect(() => {
    const updateItemWidth = () => {
      if (carouselWrapperRef.current) {
        setItemWidth(carouselWrapperRef.current.clientWidth);
      }
    };

    updateItemWidth();

    window.addEventListener('resize', updateItemWidth);

    return () => {
      window.removeEventListener('resize', updateItemWidth);
    };
  }, []); // Sem dependências, pois só precisa rodar uma vez na montagem


  const [activeService, setActiveService] = useState(areas[0]);

  // Função para mudar o serviço ativo
  const handleServiceChange = (service) => {
    setActiveService(service);
  };

//Services Slide
 const [activeIndex, setActiveIndex] = useState(0);
  const currentService = areas[activeIndex];
  const totalSlides2 = areas.length;

  const handleNext = () => {
    setActiveIndex((prevIndex) => (prevIndex + 1) % totalSlides2);
  };

  const handlePrev = () => {
    setActiveIndex((prevIndex) => (prevIndex - 1 + totalSlides2) % totalSlides2);
  };
  
  // Array para renderizar as 6 células da grade, que agora serão apenas caixas vazias
  const gridCells = [
    'businessUnit__el businessUnit__el--1x2',
    'businessUnit__el businessUnit__el--1x1',
    'businessUnit__el businessUnit__el--2x2 businessUnit__el--content',
    'businessUnit__el businessUnit__el--1x1',
    'businessUnit__el businessUnit__el--2x1',
    'businessUnit__el businessUnit__el--1x1 businessUnit__el--text',
  ];

  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);
  return (
  <>
{/*    <!-- END nav --> */}
<section className="home-slider js-fullheight owl-carousel" ref={sliderOwl} style={{height:`${windowHeight}px` }}>
    {listSlides.map((slide, index) => (
        <div key={index} className="slider-item js-fullheight" style={{ backgroundImage: `url(${slide.bg})`,height:`${windowHeight}px` }} >
          <div className="overlay" />
          <div className="container">
            <div  className="row no-gutters slider-text js-fullheight align-items-center justify-content-end" data-scrollax-parent="true" style={{height:`${windowHeight}px`}}>
              <div className="col-md-7 text ftco-animate" data-scrollax=" properties: { translateY: '70%' }" ref={setAnimatedRef}>
                <h1 className="mb-4"  data-scrollax="properties: { translateY: '30%', opacity: 1.6 }" >
                  {slide.title[i18n.language]}
                </h1>
                {slide.text && (
                  <p data-scrollax="properties: { translateY: '30%', opacity: 1.6 }" >
                    {slide.text[i18n.language]}
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      ))}
</section>

  <section className="ftco-services bg-light">
    <div className="container">
      <div className="row">
      {details.map((item, index) => (
        <div className="col-md-4 d-flex align-self-stretch ftco-animate" ref={setAnimatedRef} key={index}>
          <div className="media block-6 services d-block">
            <div className="icon d-flex justify-content-center align-items-center">
              <span className={item.icon} />
            </div>
            <div className="media-body p-2 mt-3">
              <h3 className="heading">{item.name[i18n.language]}</h3>
              <p>{item.description[i18n.language]}</p>
            </div>
          </div>
        </div>
      ))}
      </div>
    </div>
  </section>

<section className="ftco-section ftc-no-pb" id='sobrenos'>
  <div className="container">
    <div className="row no-gutters">
      <div className="col-md-6 p-md-5 img img-2" style={{backgroundImage: `url(${bg3})` }}></div>
      <div className="col-md-6 wrap-about pb-md-5 ftco-animate" ref={setAnimatedRef}>
        {listAbout.map((item, index) => (
            <React.Fragment key={index}> 
            <div className="heading-section mb-5 pl-md-5 heading-section-with-line">
                <div className="pl-md-5 ml-md-5">
                <span className="subheading">{t('navbar.sobreN')}</span>
                <h2 className="mb-4">
                    {item.bigtitle[i18n.language]}
                </h2>
                </div>
            </div>
            <div className="pl-md-5 ml-md-5 mb-5">
                <div>
                <Trans i18nKey={`cookiesPolicy_${index}`} components={{
                    1: <p />,
                    }} >
                    {item.text[i18n.language]}
                </Trans>
                </div>
            </div>
            </React.Fragment>
        ))}
      </div>
    </div>
  </div>
</section>

<section id='listServices' className='mt-5'>
  <div className="container">
    <div className="section-head center wt-small-separator-outer">
      <div className="wt-small-separator site-text-primary">
        <div className="sep-leaf-left" />
        <div>{t('servicos.title')}</div>
      </div>
      <h2 className="wt-title">{t('servicos.subtitle')}</h2>
    </div>
    <div className="s-section">
      <div className="row">
        {/* COLUMNS 1 */}
        {services.map((item) => (
        <div className="col-lg-4 col-md-6 m-b30" key={item.id}>
          <div className="service-icon-box-two">
            <div className="wt-icon-box-wraper">
              <div className="icon-xl inline-icon">
                <span className="icon-cell site-text-primary">
                  <i className={item.icon} ref={setAnimatedRef}> </i>
                </span>
              </div>
            </div>
            <div className="service-icon-box-title">
              <h4 className="wt-title" ref={setAnimatedRef}> <a href="">{item.titulo[i18n.language]}</a> </h4>
            </div>
            <div className="service-icon-box-content" ref={setAnimatedRef}> <p>{item.descri[i18n.language]}</p> </div>
          </div>
        </div>
        ))}

      </div>
    </div>
  </div>
</section>

<section id='areas' className='mt-5'>
    <div className="container">
   <div className="businessUnit__wrap businessUnit__image" style={{ backgroundImage: `url(${currentService.image})` }}>
      <div className="businessUnit__grid">
        {gridCells.map((className, index) => {
          if (className.includes('--content')) {
            return (
              <div key={index} className={className}>
                <div className="businessUnit__infos">
                  <div className="businessUnit__list">
                  {currentService.usos?.[i18n.language]?.map((uso, usoIndex) => (
                    <li key={usoIndex} className="business-unit-list__item">
                      {uso}
                    </li>
                  ))}
                  </div>
                  <div className="businessUnit__label">
                    <span>{currentService.name[i18n.language]}</span>
                  </div>
                </div>
              </div>
            );
          } else if (className.includes('--text')) {
            return (
              <div key={index} className={className}>
                <div className="title title-4 text-light text-left" dangerouslySetInnerHTML={{ __html: currentService.title }}></div>
                <h4 className="subtitle">{currentService.subTitle[i18n.language]}</h4>
                <p className="textCmp text-light">{currentService.description[i18n.language]}</p>
              </div>
            );
          } else {
            return (
              <div key={index} className={className}></div>
            );
          }
        })}
      </div>

      <div className="businessUnit__arrows">
        <button className="businessUnit__arrow prev cta-arrow-left" onClick={handlePrev} disabled={activeIndex === 0}></button>
        <button className="businessUnit__arrow next cta-arrow-right" onClick={handleNext} disabled={activeIndex === totalSlides2 - 1}></button>
      </div>
    </div>
    </div>
</section>

<section id='rdesign' className='mt-5'>
  <div className='container'>
  <div className='brandBox'>
    <div className='carouselWrapper' ref={carouselWrapperRef}>
      <div className='carouselTrack' style={{ transform: `translateX(-${currentSlide * itemWidth}px)` }}>
        {rdesignImgs.concat(rdesignImgs).map((item, index) => (
          <div className='carouselItem' key={index}>
            <img src={item.image} alt={item.name} />
          </div>
        ))}
      </div>
    </div>
  <div className='text-video'>
    {rdesign.map((item, index) => (
        <div key={index}>
            <h2 className="mb-4 text-with-logo" ref={setAnimatedRef}>
                {item.title[i18n.language]}
            </h2>
            {/* NOVO CONTÊINER FLEXBOX PARA A DESCRIÇÃO E O VÍDEO */}
            <div className='description-video-container'> 
                <p className='description' ref={setAnimatedRef}>
                    {item.text[i18n.language]}
                </p>
                <div className='video' ref={setAnimatedRef}>
                    {rdesign.map((item, videoIndex) => (
                        <video key={videoIndex} src={item.video} autoPlay loop controls={false} muted playsInline />
                    ))}
                </div>
            </div>
        </div>
    ))}
  </div>
 </div>
  </div>
</section>

  <section className='slide-brands mt-5'>
    <div className="container">
      <div className="slider-area">
        <h2>{t('parceiros.title')}</h2>
        <h5 className='text text-center'>{t('parceiros.text')}</h5>
        <div className="wrapper">
            <Slider {...settings} ref={sliderRef}>
            {ourBrands.map((item) => (
              <div className={`item ${item.name}`} key={item.id}>
                <img src={item.linkImg} alt={item.name} onLoad={() => setImagesLoaded((prev) => prev + 1)}/>
              </div>
            ))}
            </Slider>
        </div>
      </div>
    </div>
  </section>

    <section className="map_sec" id='map_sec'>
      <div className="container">
        <div className="row">
          <div className="col-md-10 offset-md-1">
            <div className="map_inner">
              <h4 className='scroll-top'>{t('footer.visitar')}</h4>
              <div className="map_bind scroll-bottom">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1523.5937968560032!2d-3.754260124876775!3d40.26914436579339!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd418a97e52ca15f%3A0x9fa22e5c82e3515d!2s!5e0!3m2!1spt-BR!2spt!4v1625400000000!5m2!1spt-BR!2spt" width="100%" height={450} allowFullScreen aria-hidden="false" tabIndex={0} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

  </>
  )
}
